import { Button, useTheme } from "@mui/material";
import React from "react";

function BuutonFilter({
  changeActiveFilterType,
  type,
  label,
  activeFilterType,
}) {
    const theme = useTheme().palette.mode;
  return (
    <Button
      onClick={()=>changeActiveFilterType(type)}
      sx={{
        color: theme === "dark" ? "#FFF" : "#262D39",
        borderBottom:
          activeFilterType === type ? "2px solid rgba(30, 106, 253, 1)" : "",
      }}
    >
      {label}
    </Button>
  );
}

export default BuutonFilter;
